<template>
  <FreeModal :name="name" persistent>
    <template #header>
      <h3 class="text-text-neutral-primary text-center text-lg font-semibold">
        {{ title }}
      </h3>
    </template>
    <template #default>
      <div class="mt-1 space-y-6">
        <p class="text-text-neutral-secondary text-center text-sm font-medium">
          {{ t('paymentErrorsModals.default.description') }}
        </p>
        <div class="text-text-neutral-secondary space-y-2">
          <FreeButton class="gray-button w-full" @click="emit('onRetry')">
            {{ t('paymentErrorsModals.retry') }}
          </FreeButton>
          <FreeButton class="gray-button w-full" @click="emit('onProceed')">
            {{ proceedButtonText }}
          </FreeButton>
        </div>
      </div>
    </template>
  </FreeModal>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  import messages from '../config/locales.json';
  import { FreeModal, FreeButton } from '../../../shared/ui';

  const props = defineProps<{
    name: string;
    isSurcharge?: boolean;
    fromCabinet?: boolean;
  }>();

  const emit = defineEmits<{
    onRetry: [];
    onProceed: [];
  }>();

  const { t } = useI18n({ messages });

  const title = computed(() =>
    t('paymentErrorsModals.default.title.base', {
      orderType: props.isSurcharge
        ? t('paymentErrorsModals.default.title.surcharge')
        : t('paymentErrorsModals.default.title.order'),
    }),
  );

  const proceedButtonText = computed(() => {
    if (props.fromCabinet) {
      return t('paymentErrorsModals.backToMain');
    }

    return props.isSurcharge
      ? t('paymentErrorsModals.returnToOrder')
      : t('paymentErrorsModals.startNewSearch');
  });
</script>
